<template>
  <div>

    <hr>
    <!-- Password, Confirm Password, Invitation Code -->
    <!-- Display User's Entered Data -->

    <b-form @submit.prevent="signUp">
      <validation-observer
        ref="accountSecurity"
        v-slot="{ invalid }"
      >
        <!-- password -->
        <b-form-group>
          <label>Password</label>
          <validation-provider
            #default="{ errors }"
            rules="required|password"
            name="password"
            vid="password"
          >
            <b-input-group
              class="input-group-merge"
              :class="errors.length > 0 ? 'is-invalid' : null"
            >
              <b-form-input
                v-model="newUser.password"
                :type="passwordFieldType"
                :state="errors.length > 0 ? false : null"
                placeholder="Password"
                autocomplete="new-password"
              />
              <b-input-group-append is-text>
                <feather-icon
                  :icon="passwordToggleIcon"
                  class="cursor-pointer"
                  @click="togglePasswordVisibility"
                />
              </b-input-group-append>
            </b-input-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <!-- confirm password -->
        <b-form-group>
          <label>Confirm Password</label>
          <validation-provider
            #default="{ errors }"
            rules="required|confirmed:password"
            name="Confirm Password"
          >
            <b-input-group
              class="input-group-merge"
              :class="errors.length > 0 ? 'is-invalid' : null"
            >
              <b-form-input
                v-model="newUser.passwordConfirm"
                :type="passwordFieldType"
                :state="errors.length > 0 ? false : null"
                placeholder="Repeat Password"
                autocomplete="new-password"
              />
              <b-input-group-append is-text>
                <feather-icon
                  :icon="passwordToggleIcon"
                  class="cursor-pointer"
                  @click="togglePasswordVisibility"
                />
              </b-input-group-append>
            </b-input-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <!-- Company Workspace -->
        <b-form-group
          label="Inivitation Code"
          label-for="inviteCode"
        >
          <validation-provider
            #default="{ errors }"
            name="Inivitation Code"
            rules="required"
          >
            <b-form-input
              id="inviteCode"
              v-model="newUser.inviteCode"
              :state="newUser.inviteCode === 'GunterKorv'"
              name="inviteCode"
              placeholder="Your secret Inivitation code"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <!-- checkbox -->
        <b-form-group>
          <validation-provider
            #default="{ errors }"
            name="status"
            rules="required"
          >
            <b-form-checkbox
              id="register-privacy-policy"
              v-model="newUser.status"
              name="checkbox-1"
            >
              I agree to
              <b-link>privacy policy & terms</b-link>
            </b-form-checkbox>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <b-button
          variant="primary"
          block
          class="mt-2"
          :disabled="invalid || loading"
          type="submit"
        >
          <div v-if="!loading">
            Sign Up
          </div>
          <div v-else>
            <b-spinner
              small
              type="grow"
              variant="light"
            />
          </div>
        </b-button>

        <b-button
          v-show="!loading"
          variant="outline-primary"
          block
          @click="$emit('prevTab')"
        >
          Previous
        </b-button>
      </validation-observer>
    </b-form>
  </div>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BFormCheckbox,
  BInputGroupAppend,
  BLink,
  BInputGroup,
  BSpinner,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'

export default {
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BFormCheckbox,
    BLink,
    BInputGroupAppend,
    BInputGroup,
    ValidationProvider,
    ValidationObserver,
    BSpinner,
  },
  mixins: [togglePasswordVisibility],
  props: {
    newUser: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      required,
      email,
      loading: false,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    async signUp() {
      this.loading = true
      const isValid = await this.$refs.accountSecurity.validate()
      if (!isValid) {
        return
      }
      this.$emit('signUp')
    },
  },

}
</script>

<style>

</style>
